module.exports = __webpack_public_path__ + "img/de.3dda74ae.svg";